import { PromotionType } from '@/types/api.generated';

import { Bet, BetPromotion } from '../hooks/types';

export const isNoSweatPromo = (
    promotion: Bet['promotion']
): promotion is BetPromotion & { type: PromotionType.NoSweat } => promotion?.type === PromotionType.NoSweat;

export const isProfitBoostPromo = (
    promotion: Bet['promotion']
): promotion is BetPromotion & { type: PromotionType.ProfitBoost } => promotion?.type === PromotionType.ProfitBoost;

/**
 * The BE keeps `potential_payout` and `amount_won` promo-exclusive and reports the bonus separately
 * on `bet.promotion`. Play and Get's bonus is a reward for placing the bet, so it never joins the payout.
 */
export const getPotentialPayoutWithBonus = (bet: Bet) =>
    bet.potential_payout + (isProfitBoostPromo(bet.promotion) ? bet.promotion.potential_bonus_amount ?? 0 : 0);

export const getAmountWonWithBonus = (bet: Bet) =>
    bet.amount_won + (isProfitBoostPromo(bet.promotion) ? bet.promotion.bonus_amount : 0);

/** The rewarded No Sweat refund, or undefined until the BE pays it out (`bonus_amount` stays 0). */
export const getNoSweatRefund = (bet: Bet): number | undefined =>
    isNoSweatPromo(bet.promotion) && bet.promotion.bonus_amount > 0 ? bet.promotion.bonus_amount : undefined;
